export const ACTIVE = 'active'
export const INACTIVE = 'inactive'
export const ZONE_STATUS = {
  ACTIVE,
  INACTIVE
}
